// extracted by mini-css-extract-plugin
module.exports = {"PodSmallRegularLayout":"HowToStart_PodSmallRegularLayout__TbQaB","PodSmallRegularBox":"HowToStart_PodSmallRegularBox__SmvMp"};